import React, { useState } from "react";
import '../../CSS/Visiter.css';
import '../../CSS/evenement_marquant.css';
import BeninInfo from "../composant_reutilisable/BeninInfo";
import Carousel from "../composant_reutilisable/Carousel";
import Africa from '../../images/Africa.svg';
import pr from '../../images/pr.png';
import voyage from '../../images/voyage.png';
import voyage1 from '../../images/voyage1.png';
import Vodun from '../../images/vodun.png';
import Senum from '../../images/senum.png';
import MenuSection from "./menuSection";
import MenuSection1 from "./menuSection1";
import { FaArrowRight } from "react-icons/fa";



const Eventes = () => {
    const [selectedCategory, setSelectedCategory] = useState("TOUS LES EVENEMENTS");

    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
        console.log(`Catégorie sélectionnée: ${category}`);
    };

    return (
        <div className="visiter-container mt-4">
            <div className="visiter-content">
                
                <MenuSection1
                    title="EVENEMENTS"
                    subtitle1="TOUS LES EVENEMENTS"
                    subtitle2="CULTURELS"
                    subtitle3="SCIENTIFIQUES"
                    subtitle4="FESTIVALS OU CONCERTS"
                    selectedCategory={selectedCategory}
                    onCategoryClick={handleCategoryClick}
                />

                {/* Premier événement */}
                <div className="affaire-container"
                    style={{
                        backgroundColor: 'transparent',
                        marginTop: '50px'
                    }}
                >
                    <div className="affaires-img">
                        <img src={Vodun} alt="Vodun days" />
                    </div>
                    <div className="affaires-text">
                        <h2 style={{ backgroundColor: '#1a3c5e', color: "#fff",  fontWeight: "semi-bold", width: "70%", padding: "5px 10px" }}>
                            UN PAYS, UNE RICHESSE, UNE CULTURE
                        </h2>
                        <p>En 2024, la Fête du Vodun, qui était traditionnellement célébrée chaque 10 janvier, s'est réinventée pour devenir un rendez-vous majeurs et inédit,
                            attirant l'attention du monde entier.
                        </p>
                        <p>La première édition des <strong>Vodun Days</strong> s'est tenue les 9 et 10 janvier 2024 à Ouidah, berceau Vodun, et a réuni près de 100 000
                            participants entre la Cité historique et la plage, à proximité de la Porte du Non-Retour. L'édition 2025 a rassemblé plus de 435 000 participants.
                        </p>
                        <p>Après ces succès retentissants , les Vodun Days reviennent en 2026, avec une édition inédite qui se déroulera sur <strong>trois jours, du 8 au 10 janvier, à Ouidah</strong>.<br />
                            Cet évènement, devenu le premier rendez-vous mondial dédié aux arts, à la culture et à la spiritualité Vodun, promet de nouvelles célébrations mémorables.
                        </p>
                        <a className="btn-investo"
                            href="https://vodundays.bj/"
                            target="_blank" rel="noopener noreferrer"
                        >
                            DÉCOUVREZ le site du vodun days
                            <FaArrowRight className="btn-icon" />
                        </a>
                    </div>
                </div>

                {/* Séparateur après le premier événement */}
                <hr className="event-separator" />

                {/* Deuxième événement */}
                <div className="affaire-container"
                    style={{
                        backgroundColor: 'transparent',
                        marginTop: '50px'
                    }}
                >
                    <div className="affaires-img">
                        <img src={Senum} alt="Senum" />
                    </div>
                    <div className="affaires-text">
                        <h2 style={{ backgroundColor: '#1a3c5e', color: "#fff",  fontWeight: "semi-bold", width: "70%", padding: "5px 10px" }}>
                            Semaine du numérique au bénin, édition 2025
                        </h2>
                        <p><strong>La SEMAINE DU NUMERIQUE, « SENUM »</strong> est l'évènement phare du secteur du numérique qui mobilise chaque année, pendant cinq (5) jours,
                            des personnalités, leaders de l'industrie des communications électroniques, entreprises privées et publiques, institutions nationales et internationales
                            et organisations de la société civile autour des enjeux de ce secteur transversal.
                        </p>
                        <p>Ce rendez-vous annuel, fait de <strong>panels, conférences, keynotes, formations, productions médiatiques et concours</strong> autour d'un thème
                            spécifique, est un prestigieux canal de promotion des cations et innovations qui animent le numérique dans la vie des hommes, des entreprises et des institutions.
                        </p>
                        <p>Cette année le SENUM aura lieu du <strong>19 au 21 novembre</strong> au Palais des congrès.
                        </p>
                        <a className="btn-investo"
                            href="https://vodundays.bj/"
                            target="_blank" rel="noopener noreferrer"
                        >
                            DÉCOUVREZ semainedunumerique.bj
                            <FaArrowRight className="btn-icon" />
                        </a>

                        <a className="btn-secondary"
                            href="https://beninrevele.bj/pag-2021-2026/"
                            target="_blank" rel="noopener noreferrer"
                            
                        >
                            PRENEZ VOTRE BADGE
                        </a>
                    </div>
                </div>

                {/* Pas de séparateur après le dernier événement */}
            </div>
        </div>
    );
};

export default Eventes;